export const getAttendanceQuery = `
query AllUserMonthlyAttendance(
  $month: Int!
  $year: Int!
  $empid: String
  $teamleader: String
) {
  allUserMonthlyAttendance(
    month: $month
    year: $year
    empid: $empid
    teamleader: $teamleader
  ) {
    success
    error
    message
    user {
      empid
      firstName
      lastName
      summary{
        totalDays
        totalPresentDays
        totalLeave
        lopDays
        totalWeekoff
        totalHolidays       
      }
      dates {
        date
        events {
          eventType
          title
          startTime
          endTime
          status
        }
      }	
    }
  }
}
`;

export const getAllManagersQuery = `
query {
  allManagers {
    id
    status
    user {
      id
      empid
      firstName
      lastName
      department
      designation
    }
  }
}`;

export const getEmployeeByManagerQuery = `
query($id: String!){
  manager(teamleaderId: $id){
    empid
    id
    firstName
    lastName
    department
    designation
  }
}`;

export const getAllEmployeesQuery = `query activeUsersDetail{
  activeUsersDetail {
    id
    username
    firstName
    lastName
    isSuperuser
    isActive
    department
    designation
    empid
    teamleader
  }
}`;